import h from 'react-hyperscript';
import Sticker from '../Sticker';
import htmlCssImg from '../images/course-cards/html-css.jpg';
import jsImg from '../images/course-cards/js.jpg';
import dataScienceImg from '../images/course-cards/data-science.jpg';


// eslint-disable-next-line
const comingSoonSticker = h(Sticker, {
    position: 'center',
    text: 'Coming soon',
    theme: 'six',
    size: 'medium'
});

export const courses = [
    {
        headerText: 'HTML & CSS',
        content: {
          '': 'In our intensive flagship two day course you will go from complete beginner to having the knowledge to build your own website and leave feeling confident about technology.',
          'Projects': 'On day two you will work on your own website and deploy it to the internet',
          'Course duration': 'This is a two day course from 10am to 5pm both days.'
        },
        theme: 'htmlCssCourse',
        link: '/html-and-css',
        linkText: 'Learn more',
        size: 'big',
        headerImage: htmlCssImg,
        badgeText: 'Beginner'
    },
    {
        headerText: 'JavaScript',
        content: {
          '': 'You will learn fundamental programming concepts and get to grips with the basics of JavaScript; the programming language of the web. ',
          'Projects': 'By the end of the course, you will build your own interactive website.',
          'Course duration': 'This is a two day course from 10am to 5pm both days.'
        },
        theme: 'jsCourse',
        badgeText: 'Intermediate',        
        // stickerText: 'Coming soon',
        size: 'big',
        headerImage: jsImg,
        link: '/javascript',
        linkText: 'Learn more'
    },
    {
        headerText: 'Data Science',
        content: {
            '': 'Learn how to use data to drive smart organisational decisions.',
            'Projects': 'Throughout this course you will analyse real world data sets to build actionable insights. For instance, previous cohorts have worked on World Bank Open Data sets.',
            'Course duration': 'This is a two day course from 10am to 5pm both days.'
        },
        theme: 'dataScienceCourse',
        badgeText: 'Beginner',
        // stickerText: 'Coming soon',
        size: 'big',
        headerImage: dataScienceImg,
        link: 'mailto:jack@codeatuni.com?subject=Data Science course inquiry',
        linkText: 'Contact us to learn more'
    }
    
    // {
    //     headerText: 'NodeJS',
    //     content: {
    //       '': '',
    //       'Projects': '',
    //       'Course duration': ''
    //     },
    //     theme: 'nodejs',
    //     // stickerText: 'Coming soon',
    //     size: 'big'
    // },
    // {
    //     headerText: 'Cybersecurity',
    //     content: {
    //       '': '',
    //       'Projects': '',
    //       'Course duration': ''
    //     },
    //     theme: 'cybersecurity',
    //     // stickerText: 'Coming soon',
    //     size: 'big'
    // },
    // {
    //     headerText: 'Data Science in Python',
    //     content: {
    //       '': '',
    //       'Projects': '',
    //       'Course duration': ''
    //     },
    //     theme: 'dataScience',
    //     // stickerText: 'Coming soon',
    //     size: 'big'
    // }
    // {
    //     headerText: 'Emerging Technology',
    //     content: {
    //       '': '',
    //       'Projects': '',
    //       'Course duration': ''
    //     },
    //     theme: 'emergingTech',
    //     // stickerText: 'Coming soon',
    //     size: 'big'
    // },
    // {
    //     headerText: 'Mobile Apps',
    //     content: {
    //       '': '',
    //       'Projects': '',
    //       'Course duration': ''
    //     },
    //     theme: 'mobileApps',
    //     // stickerText: 'Coming soon',
    //     size: 'big'
    // },
    // {
    //     headerText: 'Hackathons',
    //     content: {
    //       '': '',
    //       'Projects': '',
    //       'Course duration': ''
    //     },
    //     theme: 'hackathons',
    //     // stickerText: 'Coming soon',
    //     size: 'big'
    // },
    // {
    //     headerText: 'SQL',
    //     content: {
    //       '': '',
    //       'Projects': '',
    //       'Course duration': ''
    //     },
    //     theme: 'sql',
    //     // stickerText: 'Coming soon',
    //     size: 'big'
    // }
];



/** WEBPACK FOOTER **
 ** ./src/constants/courses.js
 **/